import React, { useContext, useEffect, useState } from "react";
import { Input } from "../../Helpers/Input/Input";
import PhoneInput from "react-phone-input-2";
import trans from "../../../utils";
import { Checkbox } from "antd";
import CustomerContact from "./CustomerContacts";
import { popupcontext } from "../../../context/Popupscontext";

export default function CustomerInfo({ addData }) {
	const { isEditing } = useContext(popupcontext);

	const [show, setShow] = useState(false);
	const [savedContact, setSavedContact] = useState(null);

	// On initial load if editing → set show & store original contact
	useEffect(() => {
		if (isEditing && addData?.values?.contactPerson?.name) {
			setShow(true);
			setSavedContact(addData.values.contactPerson); // Save original
		}
	}, [isEditing, addData?.values?.contactPerson]);

	// When show changes
	useEffect(() => {
		if (!show) {
			// hide → clear value
			addData.setFieldValue("contactPerson", null);
		} else {
			// show → restore previous if exists
			if (!addData.values.contactPerson && savedContact) {
				addData.setFieldValue("contactPerson", savedContact);
			}
		}
	}, [show]);

	return (
		<div className="userinfo mb-24">
			<p className="fs-16 fw-700 brand-700 text-uppercase">
				{trans("customer info")}
			</p>
			<div className="row">
				<div className="col-lg-6">
					<Input
						title={trans("Name")}
						type="text"
						placeholder={trans("Ex. Ahmed Ali")}
						formstyle="form-input"
						id="name"
						name="name"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.name}
						touched={addData.touched.name}
						value={addData.values.name || ""}
					/>
				</div>
				<div className="col-lg-6">
					<Input
						title={trans("Email")}
						type="email"
						placeholder="Ex@gmail.com"
						formstyle="form-input"
						id="email"
						name="email"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.email}
						touched={addData.touched.email}
						value={addData.values.email || ""}
					/>
				</div>
				<div className="col-lg-6">
					<Input
						title={trans("Password")}
						type="password"
						placeholder="*********"
						formstyle="form-input"
						id="password"
						name="password"
						onBlur={addData.handleBlur}
						onChange={addData.handleChange}
						errors={addData.errors.password}
						touched={addData.touched.password}
						value={addData.values.password || ""}
					/>
				</div>
				<div className="col-lg-6">
					<div className={`position-relative form-input `}>
						<label className="form-label text-capitalize">
							{trans("phone number")}
						</label>
						<div dir="ltr">
							<PhoneInput
								country={"ae"}
								id="phoneNumber"
								name="phoneNumber"
								disableCountryCode
								countryCodeEditable={true}
								enableSearch={true}
								disableSearchIcon
								onBlur={addData.handleBlur}
								onChange={(value) =>
									addData.setFieldValue("phoneNumber", value)
								}
								value={addData.values.phoneNumber || ""}
							/>
						</div>
					</div>
				</div>
				<div className="col-lg-6">
					<Input
						title={trans("Website")}
						type="text"
						placeholder={trans("Ex. Ahmed Ali")}
						formstyle="form-input"
						id="website"
						name="website"
						onBlur={(e) => {
							addData.handleBlur(e);
							const v = e.target.value?.trim();
							if (v) {
								let website = v;
								if (!v.startsWith("https://")) {
									website = `https://${website}`;
								}
								if (!v.endsWith(".com")) {
									website = website.endsWith("/")
										? `${website.slice(0, -1)}.com`
										: `${website}.com`;
								}
								addData.setFieldValue("website", website);
							}
						}}
						onChange={addData.handleChange}
						errors={addData.errors.website}
						touched={addData.touched.website}
						value={addData.values.website || ""}
					/>
				</div>
				<div className="col-lg-6">
					<div className={`position-relative form-input`}>
						<label className="form-label">{trans("Fax")}</label>
						<div dir="ltr">
							<PhoneInput
								country={"ae"}
								id="fax"
								name="fax"
								inputClass="phone-input"
								containerClass="phone-input-container"
								disableCountryCode
								countryCodeEditable={true}
								enableSearch={true}
								disableSearchIcon
								onBlur={addData.handleBlur}
								onChange={(value) => addData.setFieldValue("fax", value)}
								value={addData?.values?.fax || ""}
								errors={addData?.errors?.fax ? addData?.errors?.fax : null}
								touched={addData?.touched.fax ? addData?.touched?.fax : null}
							/>
						</div>
					</div>
				</div>
				<div className="col-lg-12 d-flex">
					<Checkbox checked={show} onChange={() => setShow((prev) => !prev)} />
					<div className="form-label text-capitalize mb-1 mx-2">
						{trans("customer contact")}
					</div>
				</div>
				{show && <CustomerContact addData={addData} show={show} />}
			</div>
		</div>
	);
}
